export const rootRoute = {
  title: 'Home',
  path: '/'
}

export const homeRoute = {
  title: 'Home',
  path: '/home'
}
export const locationRoute = {
  title: 'Home',
  path: '/:locationId(\\d+)'
}

export const selectLocationRoute = {
  title: 'Search for an address',
  path: '/select-location'
}
export const noLocationRoute = {
  title: 'Location Not Found',
  path: '/no-location'
}
export const loginRoute = {
  title: 'Login',
  path: process.env.REACT_APP_LOGIN_URL
}
export const logoutRoute = {
  title: 'Logout',
  path: '/logout'
}
export const registerRoute = {
  title: 'Register',
  path: '/register'
}
export const forgotPasswordRoute = {
  title: 'Forgot Password',
  path: '/forgot-password'
}
export const changePasswordRoute = {
  title: 'Change Password',
  path: '/change-password/:token'
}
export const unsubscribeRoute = {
  title: 'Unsubscribe',
  path: '/unsubscribe'
}
export const profileRoute = {
  title: 'Profile',
  path: '/profile'
}
export const historyRoute = {
  title: 'History',
  path: '/history'
}

export const creditsRoute = {
  title: 'Credits',
  path: '/credits'
}

export const termsAndConditionsRoute = {
  title: 'Terms and Conditions',
  path: '/terms-and-conditions'
}
export const privacyPolicyRoute = {
  title: 'Privacy',
  path: '/privacy'
}

export const contactRoute = {
  title: 'Contact',
  path: '/contact'
}
export const contactUsRoute = {
  title: 'Contact Us',
  path: '/contact-us'
}
export const thankYouRoute = {
  title: 'Thank You',
  path: '/thank-you'
}
export const placeOrderRoute = {
  title: 'Place Order',
  path: '/:locationId(\\d+)/deliveries/:dropoffId(\\d+)/order'
}
export const personalizeRoute = {
  title: 'Personalize',
  path:
    '/:locationId(\\d+)/deliveries/:dropoffId(\\d+)/order/:itemId(\\d+)/personalize'
}
export const checkoutInterstitialRoute = {
  title: 'Login to Checkout',
  path: '/:locationId(\\d+)/deliveries/:dropoffId(\\d+)/login'
}
export const checkoutRoute = {
  title: 'Checkout',
  path: '/:locationId(\\d+)/deliveries/:dropoffId(\\d+)/checkout'
}
export const confirmationRoute = {
  title: 'Confirmation',
  path: '/confirmation/:orderId(\\d+)/:locationId(\\d+)'
}

export const maintenanceRoute = {
  title: 'This page is under maintenance',
  path: '/maintenance'
}

export const joinRoute = {
  title: 'Join Foodsby',
  path: '/join/:token'
}

export const friendsRoute = {
  title: 'Friends',
  path: '/friends'
}

export const completeAccountRoute = {
  title: 'Complete Your Account',
  path: '/complete-account/:token'
}
